<div [ngClass]="labelTextTransformNone ? 'input-field-name-none': 'input-field-name'" *ngIf="labelName">
  {{ labelName }}<span class="optional" *ngIf="!isRequiredField">({{OPTIONAL}})</span>
</div>

  <input
    type="file"
    name="profile"
    value="Choose File"
    [ngClass]="
      inputFormControl && (submitted || inputFormControl.touched) && inputFormControl.errors
        ? 'error-input'
        : ''
    "
    [formControl]="inputFormControl"
    (change)="onSelect($event)"
    />

<div
  [ngClass]="labelTextTransformNone ? 'error-none': 'error'"
  *ngIf="inputFormControl && (submitted || inputFormControl.touched) && inputFormControl.errors"
>


  <div *ngIf="inputFormControl.errors.required">
    {{ labelName }} is required.
  </div>

  <div *ngIf="inputFormControl.errors.invalidFileExtension">
    Cannot accept file other than  word, jpg ,rar and pdf format.
  </div>

</div>
